/* eslint-disable max-len */
import { GetIAMAvailableModulesResponse } from '@1po/1po-bff-fe-spec/generated/catalog/available_modules/response/GetIAMAvailableModulesResponse';
import { GET_IAM_AVAILABLE_MODULES_RESPONSE } from '@1po/1po-bff-fe-spec/generated/common/ResponseType';
import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import { RootState } from 'app/AppStore';
import {
  GET_IAM_AVAILABLE_MODULES_REQUEST,
  IAM_MODULES_NAMESPACE,
  IamModulesState,
} from 'domains/catalog/CatalogIam.types';
import { NO_DATA } from 'utils';

const initialState: IamModulesState = {
  availableModules: undefined,
};

// Saga actions
export const fetchIAMAvailableModulesRequestSaga = createAction(GET_IAM_AVAILABLE_MODULES_REQUEST);
export const fetchIAMAvailableModulesResponseSaga = createAction(GET_IAM_AVAILABLE_MODULES_RESPONSE);

// Slice
const slice = createSlice({
  name: IAM_MODULES_NAMESPACE,
  initialState,
  reducers: {
    setInitialState: () => initialState,
    setAvailableModulesStatus: (state, { payload }: PayloadAction<{ status: NO_DATA }>) => {
      state.availableModules = payload.status;
    },
    setAvailableModules: (state, { payload }: PayloadAction<GetIAMAvailableModulesResponse>) => {
      state.availableModules = payload;
    },
    resetAvailableModules: (state) => {
      state.availableModules = undefined;
    },
  },
});

// Actions
export const { setInitialState, setAvailableModules, setAvailableModulesStatus, resetAvailableModules } = slice.actions;

export const getIAMAvailableModules = createSelector(
  (state: RootState) => state.iamModules.availableModules,
  (availableModules) => availableModules,
);

// Export reducer
export default slice.reducer;
